import { cn } from "@local/utils/src/cn"
import { barlowCondensed } from "../../utils"
import { ArrowLeftIcon } from "./icons"
import type { HTMLAttributes } from "react"

export interface ArrowTitleProps extends HTMLAttributes<HTMLHeadingElement> {
  headline: string
  iconClassName?: string
}

export const ArrowTitle = ({
  headline,
  iconClassName,
  ...props
}: ArrowTitleProps) => {
  return (
    <h2
      className={`${barlowCondensed.className} flex text-4xl leading-tight tracking-[-0.02em] uppercase md:relative md:text-5xl`}
      {...props}
    >
      <ArrowLeftIcon
        className={cn(
          "top-3 -left-12 mr-2 hidden w-9 rotate-180 text-gray-200 md:absolute md:mr-0 xl:block",
          iconClassName
        )}
      />
      <span dangerouslySetInnerHTML={{ __html: headline }} />
    </h2>
  )
}
